import { sportsimPath } from './sportConfig';
// A brief public fixture snapshot serves the tip dialog and simulation tab.
// Writes remain validated by the server; private account/prediction data bypasses it.
const snapshots = new Map();
export function simulationFixtures(key) {
  const previous = snapshots.get(key);
  if (previous && Date.now() < previous.expires) return previous.promise;
  const promise = fetch(sportsimPath(`/matches?simulation=${encodeURIComponent(key)}`)).then(async response => {
    const body = await response.json();
    if (!response.ok) throw new Error(body.detail || 'Matchernas simulering kunde inte hämtas.');
    return body;
  }).catch(error => { snapshots.delete(key); throw error; });
  snapshots.set(key,{promise,expires:Date.now()+10000});
  return promise;
}
